import gql from 'graphql-tag';

export const SaveApprovalTaskItemMutation = gql`
  mutation ($approvalTaskItem: ApprovalTaskItemInput!, $applicationId: String, $approvalTaskId: String) {
    saveApprovalTaskItem (approvalTaskItem: $approvalTaskItem, applicationId: $applicationId, approvalTaskId: $approvalTaskId) 
    {
      id
      name
      itemNote
      typeCode
      typeCodeOptionSet
      stateCode
      stateCodeOptionSet
      statusCode
      statusCodeOptionSet
      allowRecordCreation
      isRequired
      payloadTypeCode
      payloadTypeCodeOptionSet
      payloadName
      payload
      submitDate
      submissionReject
      approvalTaskItemKey
    }
  }
`;

export const DeleteApprovalTaskItemMutation = gql`
  mutation ($approvalTaskItemId: String,$applicationId: String) {
    deleteApprovalTaskItem (approvalTaskItemId: $approvalTaskItemId,applicationId: $applicationId)
    {
      id
    }
  }
`;
export const DeactivateApprovalTaskItemMutation = gql`
  mutation ($approvalTaskItemId: String,$applicationId: String) {
    deactivateApprovalTaskItem (approvalTaskItemId: $approvalTaskItemId,applicationId: $applicationId)
    {
      id
    }
  }
`;